<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card card-sm">
        <!-- HEADER con filtros -->
        <div class="card-header" style="background-color: #DBECDB;">
          <div class="card-title row">
            <div class="col-md-4">
              <div class="input-group">
                <label class="form-label">Reporte: </label> 
                <select 
                  v-model="filters.reporte" 
                  class="form-select"
                  @change="handleReporteChange"
                >
                  <option value="Economico">Económico</option>
                  <option value="Valorado">Valorado</option>
                  <option value="ValoradoME">Valorado M.E.</option>
                  <option value="Tramite">Tipo de Trámite</option>
                </select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Gestión: </label>
                  <select 
                    v-model="filters.gestion" 
                    class="form-select"
                  >
                    <option v-for="year in gestiones" :key="year" :value="year">
                      {{ year }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            
            <!-- Filtros dinámicos según reporte -->
            <div class="col-md-6" v-if="filters.reporte === 'Economico'">
              <div class="form-group">
                <div class="input-group">
                  <label>Unidad:</label>
                  <select 
                    v-model="filters.id_unidad" 
                    class="form-select"
                    @change="fetchAreas"
                  >
                    <option value="">Todas las unidades</option>
                    <option 
                      v-for="unidad in unidades" 
                      :key="unidad.id" 
                      :value="unidad.id"
                    >
                      {{ unidad.nombre_unidad }} ({{ unidad.codigo }})
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-md-6" v-if="filters.reporte === 'Valorado' || filters.reporte === 'ValoradoME'">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Valorado: </label>
                  <select v-model="filters.valorado" class="form-select">
                    <option value="">Todos los valorados</option>
                    <option 
                      v-for="valor in valorados" 
                      :key="valor.id" 
                      :value="valor.id"
                    >
                      {{ valor.descripcion }} 
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- Segunda fila de filtros -->
          <div class="row mb-3">
            <div class="col-md-6" v-if="filters.reporte === 'Economico'">
              <div class="form-group">
                <div class="input-group">
                  <label>Sección:</label>
                  <select 
                    v-model="filters.id_area" 
                    class="form-select"
                    @change="fetchTipotramites"
                  >
                    <option value="">Todas las secciones</option>
                    <option 
                      v-for="area in areas" 
                      :key="area.id" 
                      :value="area.id"
                    >
                      ({{ area.codigo }}) {{ area.nombre_area }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-md-6" v-if="filters.reporte === 'Economico' || filters.reporte === 'Tramite'">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Tipo Trámite: </label>
                  <select v-model="filters.tipotramite" class="form-select">
                    <option value="">Todos</option>
                    <option 
                      v-for="tipo in tipotramites" 
                      :key="tipo.id" 
                      :value="tipo.id"
                    >
                      {{ tipo.tipo }} 
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- Filtros de fecha -->
          <div class="row mb-3">
            <div class="col-md-2">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Período: </label>
                  <select v-model="filters.tipo" class="form-select" @change="handleTipoChange">
                    <option value="">Rango</option>
                    <option value="Diario">Diario</option>
                    <option value="Mensual">Mensual</option>
                    <option value="Anual">Anual</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Fecha según tipo -->
            <div class="col-md-3" v-if="showMes">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Mes: </label>
                  <select v-model="filters.mes" class="form-select">
                    <option v-for="mes in meses" :key="mes.valor" :value="mes.valor">
                      {{ mes.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-md-3" v-if="showFecha">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Fecha: </label>
                  <input
                    type="date"
                    v-model="filters.fecha"
                    class="form-control"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-3" v-if="showDesdeHasta">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Desde: </label>
                  <input
                    type="date"
                    v-model="filters.desde"
                    class="form-control"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-3" v-if="showDesdeHasta">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Hasta: </label>
                  <input
                    type="date"
                    v-model="filters.hasta"
                    class="form-control"
                  />
                </div>
              </div>
            </div>

            <!-- Filtros adicionales -->
            <div class="col-md-3" v-if="filters.reporte === 'Eco'">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Técnico: </label>
                  <select v-model="filters.tecnico" class="form-select">
                    <option value="">Todos</option>
                    <option v-for="tec in tecnicos" :key="tec.username" :value="tec.username">
                      {{ tec.nombre_completo }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-md-2" v-if="filters.reporte === 'Economico'">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Nro Deposito: </label>
                  <input v-model="filters.nro_deposito" class="form-control">
                </div>
              </div>
            </div>

            <div class="col-md-2" v-if="filters.reporte === 'Valorado' || filters.reporte === 'ValoradoME' || filters.reporte === 'Economico'">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Ventanilla: </label>
                  <select v-model="filters.ventanilla" class="form-select">
                    <option value="">Todos</option>
                    <option v-for="ven in ventanillas" :key="ven.id" :value="ven.id">
                      {{ ven.nombre_completo }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Botones de acción -->
            <div class="col-md-3 d-flex align-items-center">
              <BButton 
                class="btn btn-sm btn-secondary me-2" 
                @click="handleSearch"
              >
                <i class="fa fa-search"></i> Buscar
              </BButton>
              <BButton
                variant="danger"
                class="btn btn-sm"
                @click="generatePDF"
              >
                <i class="fa fa-file-pdf me-1"></i> PDF
              </BButton>
            </div>
          </div>
        </div>

        <div class="card-body pt-1">
          <div class="row mb-3" v-if="!loading && resumen.total_global > 0">
            <div class="col-md-2">
              <div class="card bg-primary text-white">
                <div class="card-body py-2">
                  <h6 class="card-title">Total Registros</h6>
                  <h5 class="mb-0">{{ resumen.total_global }}</h5>
                </div>
              </div>
            </div>
            
            <div class="col-md-3" v-if="resumen.monto_total_global !== undefined">
              <div class="card bg-success text-white">
                <div class="card-body py-2">
                  <h6 class="card-title">Monto Total</h6>
                  <h5 class="mb-0">{{ formatMoney(resumen.monto_total_global) }}</h5>
                </div>
              </div>
            </div>
            
            <div class="col-md-3" v-if="resumen.resto_total_global !== undefined">
              <div class="card bg-warning">
                <div class="card-body py-2">
                  <h6 class="card-title">Demasía Total</h6>
                  <h5 class="mb-0">{{ formatMoney(resumen.resto_total_global) }}</h5>
                </div>
              </div>
            </div>
            
            <!-- RANGO DE FECHAS -->
            <div class="col-md-4">
              <div class="card bg-info text-white">
                <div class="card-body py-2">
                  <h6 class="card-title">Rango Fechas</h6>
                  <h5 stile="font-size:8rem" class="mb-0">{{ rangoFechas }}</h5>
                </div>
              </div>
            </div>
          </div>

          <div v-if="loading" class="text-center py-1">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
            <p class="mt-2">Generando reporte...</p>
          </div>

          <div v-else>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover table-bordered" style="font-size: 0.8rem;">
                <thead class="text-primary">
                  <tr>
                    <th v-for="col in columnas" :key="col.key">{{ col.label }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="item.id || index">
                    <td v-for="col in columnas" :key="col.key" :class="col.class">
                      {{ formatField(item, col, index) }}
                    </td>
                  </tr>
                  <tr v-if="items.length === 0">
                    <td :colspan="columnas.length" class="text-center py-4">
                      No hay datos para mostrar con los filtros seleccionados
                    </td>
                  </tr>
                </tbody>
                <!-- PIE DE TABLA CON TOTALES -->
                <tfoot v-if="items.length > 0" class="bg-light font-weight-bold">
                  <tr>
                    <td :colspan="colspanTotal" class="text-right">
                      <strong>TOTALES ({{ resumen.total_global }} registros):</strong>
                    </td>
                    <td v-if="muestraMontoTotal" class="text-right">
                      <strong>{{ formatMoney(resumen.monto_total_global) }}</strong>
                    </td>
                    <td v-if="muestraRestoTotal" class="text-right">
                      <strong>{{ formatMoney(resumen.resto_total_global) }}</strong>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            
            <div class="row mt-3" v-if="pagination.total > 0">
              <div class="col-md-6">
                <p class="text-muted">
                  Mostrando {{ pagination.from }} - {{ pagination.to }} de {{ pagination.total }} registros
                  <span v-if="resumen.monto_total_global">
                    | Total global: {{ formatMoney(resumen.monto_total_global) }}
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <BPagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.per_page"
                  @page-click="handlePageClick"
                  align="right"
                  size="sm"
                ></BPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, watch } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BButton, BPagination } from 'bootstrap-vue-3';

export default {
  name: 'ReporteEconomico',
  components: {
    BButton,
    BPagination
  },
  setup() {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    
    const filters = reactive({
      reporte: 'Economico',
      id_unidad: '',
      id_area: '',
      tipotramite: '',
      gestion: today.getFullYear(),
      tipo: '',
      fecha: today.toISOString().split('T')[0],
      mes: today.getMonth() + 1,
      desde: firstDay.toISOString().split('T')[0],
      hasta: today.toISOString().split('T')[0],
      tecnico: '',
      ventanilla: '',
      valorado: '',
      serie: '',
      numero: '',
      nro_deposito: ''
    });

    // Datos
    const items = ref([]);
    const loading = ref(false);
    
    // Catálogos
    const unidades = ref([]);
    const areas = ref([]);
    const tipotramites = ref([]);
    const tecnicos = ref([]);
    const valorados = ref([]);
    const ventanillas = ref([]);

    // Paginación
    const pagination = reactive({
      current_page: 1,
      per_page: 15,
      total: 0,
      last_page: 1,
      from: 0,
      to: 0
    });

    // RESUMEN - usando totales del backend
    const resumen = reactive({
      total_global: 0,
      monto_total_global: 0,
      monto_total_pagina: 0,
      resto_total_global: 0
    });

    const gestiones = computed(() => {
      const year = today.getFullYear();
      return [year - 2, year - 1, year, year + 1];
    });

    const meses = [
      { valor: 1, nombre: 'Enero' },
      { valor: 2, nombre: 'Febrero' },
      { valor: 3, nombre: 'Marzo' },
      { valor: 4, nombre: 'Abril' },
      { valor: 5, nombre: 'Mayo' },
      { valor: 6, nombre: 'Junio' },
      { valor: 7, nombre: 'Julio' },
      { valor: 8, nombre: 'Agosto' },
      { valor: 9, nombre: 'Septiembre' },
      { valor: 10, nombre: 'Octubre' },
      { valor: 11, nombre: 'Noviembre' },
      { valor: 12, nombre: 'Diciembre' }
    ];

    const showMes = computed(() => filters.tipo === 'Mensual');
    const showFecha = computed(() => filters.tipo === 'Diario');
    const showDesdeHasta = computed(() => !filters.tipo || filters.tipo === '');

    // Columnas dinámicas según tipo de reporte
    const columnas = computed(() => {
      const base = [
        { key: 'index', label: '#', class: 'text-center' }
      ];

      if (filters.reporte === 'Economico') {
        return [
          ...base,
          { key: 'fecha_proceso', label: 'Fecha', class: 'text-center' },
          { key: 'codigo', label: 'Codigo', class: 'text-center' },
          { key: 'tipo_tramite', label: 'Trámite' },
          { key: 'nro_deposito', label: 'N° Depósito', class: 'text-center' },
          { key: 'monto', label: 'Monto Bs', class: 'text-right' },
          { key: 'canje_cantidad', label: 'Cantidad', class: 'text-center' },
          { key: 'canje_monto', label: 'Total Bs', class: 'text-right' },
          { key: 'costo', label: 'Importe Bs', class: 'text-right' },
          { key: 'resto', label: 'Demasía', class: 'text-right' }
        ];
      } else if (filters.reporte === 'Valorado' || filters.reporte === 'ValoradoME') {
        return [
          ...base,
          { key: 'fecha_canje', label: 'Fecha Canje', class: 'text-center' },
          { key: 'descripcion_valorado', label: 'Valorado' },
          { key: 'nro_deposito', label: 'Nro. Deposito' },
          { key: 'serie', label: 'Serie', class: 'text-center' },
          { key: 'numero', label: 'Número', class: 'text-center' },
          { key: 'costo', label: 'P.U.', class: 'text-right' },
          { key: 'monto', label: 'Total Bs', class: 'text-right' }
        ];
      } else if (filters.reporte === 'Tramite') {
        return [
          ...base,
          { key: 'fecha_recepcion', label: 'Fecha Recepción', class: 'text-center' },
          { key: 'fecha_aprobacion', label: 'Fecha Aprobación', class: 'text-center' },
          { key: 'importe_dde', label: 'Importe DDE', class: 'text-right' },
          { key: 'importe_minedu', label: 'Importe MINEDU', class: 'text-right' },
          { key: 'importe_val', label: 'Importe Val', class: 'text-right' }
        ];
      }
      return base;
    });

    const colspanTotal = computed(() => {
      let cols = columnas.value.length;
      if (muestraMontoTotal.value) cols -= 1;
      if (muestraRestoTotal.value) cols -= 1;
      return cols;
    });

    const muestraMontoTotal = computed(() => {
      return filters.reporte === 'Economico' || filters.reporte === 'Valorado' || filters.reporte === 'ValoradoME';
    });

    const muestraRestoTotal = computed(() => {
      return filters.reporte === 'Economico';
    });

    const rangoFechas = computed(() => {
      if (filters.tipo === 'Diario' && filters.fecha) {
        return `Día: ${formatDate(filters.fecha)}`;
      } else if (filters.tipo === 'Mensual' && filters.mes) {
        const mes = meses.find(m => m.valor === parseInt(filters.mes))?.nombre || filters.mes;
        return `Mes: ${mes} ${filters.gestion}`;
      } else if (filters.tipo === 'Anual') {
        return `Gestión: ${filters.gestion}`;
      } else if (filters.desde && filters.hasta) {
        return `${formatDate(filters.desde)} - ${formatDate(filters.hasta)}`;
      }
      return 'Todos los períodos';
    });
    
    // ============ MÉTODOS ============
    const formatDate = (date) => {
      if (!date) return '';
      
      try {
        const dateObj = new Date(date);
        if (isNaN(dateObj.getTime())) return '';
        
        // Usar toLocaleDateString con zona horaria UTC
        return dateObj.toLocaleDateString('es-ES', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          timeZone: 'UTC' // Forzar UTC
        });
        
      } catch (error) {
        return '';
      }
    };

    const formatMoney = (value) => {
      if (value === null || value === undefined) return 'Bs 0,00';
      const numero = typeof value === 'string' ? parseFloat(value) : value;
      if (isNaN(numero)) return 'Bs 0,00';
      return 'Bs ' + new Intl.NumberFormat('es-BO', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      }).format(numero);
    };

    const formatField = (item, column, index) => {
      if (column.key === 'index') {
        return ((pagination.current_page - 1) * pagination.per_page) + index + 1;
      }
      
      const value = item[column.key];
      
      if (column.class?.includes('text-right') && value !== null && value !== undefined) {
        return formatMoney(value);
      }
      
      return value || '';
    };

    // ============ FETCH DATA ============
    const fetchData = async () => {
      loading.value = true;
      
      try {
        // Construir parámetros
        const params = {
          reporte: filters.reporte,
          page: pagination.current_page,
          per_page: pagination.per_page,
          gestion: filters.gestion
        };

        // Filtros opcionales
        if (filters.id_unidad) params.id_unidad = filters.id_unidad;
        if (filters.id_area) params.id_area = filters.id_area;
        if (filters.tipotramite) params.tipotramite = filters.tipotramite;
        if (filters.tipo) params.tipo = filters.tipo;
        if (filters.tecnico) params.tecnico = filters.tecnico;
        if (filters.ventanilla) params.ventanilla = filters.ventanilla;
        if (filters.valorado) params.valorado = filters.valorado;
        if (filters.nro_deposito) params.nro_deposito = filters.nro_deposito;

        // Fechas según tipo
        if (filters.tipo === 'Diario' && filters.fecha) {
          params.fecha = filters.fecha;
        } else if (filters.tipo === 'Mensual' && filters.mes) {
          params.mes = filters.mes;
        } else if (!filters.tipo) {
          if (filters.desde) params.desde = filters.desde;
          if (filters.hasta) params.hasta = filters.hasta;
        }

        const response = await axios.get('/reportes-eco/economico', { params });
        
        if (response.data.success && response.data.datos) {
          const data = response.data.datos;
          
          // Datos de la página actual
          items.value = data.data || [];
          
          // Información de paginación
          pagination.current_page = data.current_page;
          pagination.per_page = data.per_page;
          pagination.total = data.total;
          pagination.last_page = data.last_page;
          pagination.from = data.from;
          pagination.to = data.to;
          
          // TOTALES GLOBALES DEL BACKEND
          resumen.total_global = data.total_registros_global || data.total || 0;
          resumen.monto_total_global = parseFloat(data.monto_total_global) || 0;
          resumen.resto_total_global = parseFloat(data.resto_total_global) || 0;
          
          // Calcular totales de la página actual (para referencia)
          resumen.monto_total_pagina = items.value.reduce((sum, item) => {
            return sum + (parseFloat(item.monto) || 0);
          }, 0);
        }
        
      } catch (error) {
        console.error('Error al cargar datos:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los datos'
        });
      } finally {
        loading.value = false;
      }
    };

    // ============ CATÁLOGOS ============
    const fetchUnidades = async () => {
      try {
        const response = await axios.get('/unidad/select');
        unidades.value = response.data.unidades || [];
      } catch (error) {
        console.error('Error al cargar unidades:', error);
      }
    };

    const fetchAreas = async () => {
      if (!filters.id_unidad) {
        areas.value = [];
        return;
      }
      
      try {
        const response = await axios.get('/area/select', {
          params: { id_unidad: filters.id_unidad }
        });
        areas.value = response.data.areas || [];
        filters.id_area = ''; // Reset al cambiar unidad
      } catch (error) {
        console.error('Error al cargar áreas:', error);
      }
    };

    const fetchTipotramites = async () => {
      try {
        const params = {};
        if (filters.id_unidad) params.id_unidad = filters.id_unidad;
        if (filters.id_area) params.id_area = filters.id_area;
        
        const response = await axios.get('/tipotramite/selectreporte', { params });
        tipotramites.value = response.data.tipotramites || [];
      } catch (error) {
        console.error('Error al cargar tipos de trámite:', error);
      }
    };

    const fetchTecnicos = async () => {
      try {
        const params = {};
        if (filters.id_unidad) params.id_unidad = filters.id_unidad;
        if (filters.id_area) params.id_area = filters.id_area;
        
        const response = await axios.get('/tipotramite/selecventanilla', { params });
        tecnicos.value = response.data.tecnicos || [];
      } catch (error) {
        console.error('Error al cargar técnicos:', error);
      }
    };

    const fetchValorados = async () => {
      try {
        const response = await axios.get('/tipotramite/selectvaloradorep');
        valorados.value = response.data.valorados || [];
      } catch (error) {
        console.error('Error al cargar valorados:', error);
      }
    };

    const fetchVentanillas = async () => {
      try {
        const response = await axios.get('/tipotramite/selectventanilla');
        ventanillas.value = response.data.ventanilla || [];
      } catch (error) {
        console.error('Error al cargar ventanillas:', error);
      }
    };

    // ============ HANDLERS ============
    const handleSearch = () => {
      pagination.current_page = 1;
      fetchData();
    };

    const handlePageClick = (event, page) => {
      event.preventDefault();
      pagination.current_page = page;
      fetchData();
    };

    const handleReporteChange = () => {
      // Resetear filtros específicos al cambiar tipo de reporte
      filters.id_unidad = '';
      filters.id_area = '';
      filters.tipotramite = '';
      filters.tecnico = '';
      filters.ventanilla = '';
      filters.valorado = '';
      
      // Cargar catálogos según reporte
      if (filters.reporte === 'Economico') {
        fetchUnidades();
        fetchTecnicos();
      } else if (filters.reporte === 'Valorado' || filters.reporte === 'ValoradoME') {
        fetchValorados();
        fetchVentanillas();
      } else if (filters.reporte === 'Tramite') {
        fetchTipotramites();
      }
      
      handleSearch();
    };

    const handleTipoChange = () => {
      // Resetear valores según tipo seleccionado
      if (filters.tipo === 'Diario') {
        filters.mes = null;
        filters.desde = '';
        filters.hasta = '';
      } else if (filters.tipo === 'Mensual') {
        filters.fecha = '';
        filters.desde = '';
        filters.hasta = '';
      } else if (filters.tipo === 'Anual') {
        filters.fecha = '';
        filters.mes = null;
        filters.desde = '';
        filters.hasta = '';
      }
    };

    const generatePDF = async () => {
      try {
        // Construir mismos parámetros que fetchData
        const params = {
          reporte: filters.reporte,
          gestion: filters.gestion
        };

        if (filters.id_unidad) params.id_unidad = filters.id_unidad;
        if (filters.id_area) params.id_area = filters.id_area;
        if (filters.tipotramite) params.tipotramite = filters.tipotramite;
        if (filters.tipo) params.tipo = filters.tipo;
        if (filters.tecnico) params.tecnico = filters.tecnico;
        if (filters.ventanilla) params.ventanilla = filters.ventanilla;
        if (filters.valorado) params.valorado = filters.valorado;
        if (filters.nro_deposito) params.nro_deposito = filters.nro_deposito;

        if (filters.tipo === 'Diario' && filters.fecha) {
          params.fecha = filters.fecha;
        } else if (filters.tipo === 'Mensual' && filters.mes) {
          params.mes = filters.mes;
        } else if (!filters.tipo) {
          if (filters.desde) params.desde = filters.desde;
          if (filters.hasta) params.hasta = filters.hasta;
        }

        Swal.fire({
          title: 'Generando PDF',
          text: 'Por favor espere...',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const response = await axios.get('/reportes-eco/economicopdf', {
          params,
          responseType: 'blob',
          timeout: 300000 // 5 minutos
        });

        Swal.close();

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `reporte-${filters.reporte.toLowerCase()}-${filters.gestion}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF. Intente con un rango más pequeño.'
        });
      }
    };

    // ============ WATCHERS ============
    watch(() => filters.id_unidad, () => {
      fetchAreas();
      fetchTipotramites();
      fetchTecnicos();
    });

    watch(() => filters.id_area, () => {
      fetchTipotramites();
      fetchTecnicos();
    });

    // ============ INIT ============
    onMounted(() => {
      fetchUnidades();
      fetchValorados();
      fetchVentanillas();
      fetchData();
    });

    return {
      // Estado
      filters,
      items,
      loading,
      unidades,
      areas,
      tipotramites,
      tecnicos,
      valorados,
      ventanillas,
      pagination,
      resumen,
      
      // Computadas
      gestiones,
      meses,
      showMes,
      showFecha,
      showDesdeHasta,
      columnas,
      colspanTotal,
      muestraMontoTotal,
      muestraRestoTotal,
      rangoFechas,
      
      // Métodos
      handleReporteChange,
      handleTipoChange,
      handleSearch,
      handlePageClick,
      generatePDF,
      fetchAreas,
      fetchTipotramites,
      formatMoney,
      formatField
    };
  }
};
</script>

<style scoped>
thead th {
  background-color: #D84315;
  color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 10;
  font-size: 0.75rem;
  white-space: nowrap;
}

tbody td {
  padding: 6px !important;
  vertical-align: middle;
}

tfoot td {
  background-color: #f8f9fa;
  font-weight: bold;
}

.table-responsive {
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.card-header .input-group {
  align-items: center;
  gap: 5px;
}

.card-header label {
  min-width: 60px;
  margin-bottom: 0;
  font-weight: 500;
  font-size: 0.85rem;
}

.card-header select,
.card-header input {
  font-size: 0.85rem;
}

.bg-primary {
  background: #667eea;
}

.bg-success {
  background: #43e97b;
}

.bg-warning {
  background: #fa709a;
}

.bg-info {
  background: #4facfe;
}

.card-body {
  padding: 0.75rem;
}

.card-title {
  margin-bottom: 0.25rem;
  font-size: 0.85rem;
}

h4, h6 {
  margin: 0;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.7) !important;
  font-size: 0.7rem;
}
</style>